import { remove } from 'lodash';

import { Content, ContentInput, GroupIdApproval } from 'api';
import { UserGroup } from 'types/app';
import { hasBody, hasCommentary, hasGroup, hasPhoto, hasUrl } from 'features/content/helpers';

export const bodyEndsWithUrl = (url: string, body: string) => {
  const urlIndex = body.lastIndexOf(url);

  if (urlIndex < 0) {
    return false;
  }

  return urlIndex + url.length === body.length;
};

export const stripTrailingUrl = (url: string, body: string) => body.replace(url, '');

export const getSafeBody = (body: string) => {
  return body === '' ? null : body;
};

export const formatBody = (content: ContentInput) => {
  const { content_object } = content;
  const { body, url } = content_object;

  if (bodyEndsWithUrl(url, body)) {
    return getSafeBody(stripTrailingUrl(url, body));
  }

  return getSafeBody(body);
};

export const formatCommentary = (content: ContentInput) => {
  if (!hasCommentary(content)) {
    return null;
  }

  return remove(content.commentary, commentary => !!commentary.commentary);
};

export const isApprovedGroup = (content: Content, group: UserGroup) => {
  return content.group_id_approvals.some((approval: GroupIdApproval) => {
    return approval.group_id === group.id;
  });
};

export const isValidPost = (content: ContentInput) => {
  const containsContent = !!(hasBody(content) || hasUrl(content) || hasPhoto(content));
  return containsContent && hasGroup(content);
};
